module.exports = __webpack_public_path__ + "static/media/API test cases.a7295903.xlsx";